import { getAppConfig } from '@bts-web/core-app-config';
import {
  getRoundedPrecision,
  intlFiatValueFormatting,
  PrecisionFloat,
} from '@bts-web/utils-formatting';

export function formattedAmount(field: PrecisionFloat, locale?: string) {
  const { currency } = getAppConfig();

  return intlFiatValueFormatting(Number(getRoundedPrecision(field)), {
    locale: locale,
    fractionDigits: field?.precision,
    currency,
  });
}
